import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal, List, Spin } from "antd";
import { apiUrl } from '../../utility/Connections';
import TableRelationshipsLinks from "../tableRelationshipsLinks/tableRelationshipsLinks";

// Este componente recibe evl_id como prop
const ModalEvaluationLinks = ({ visible, onClose, evl_id }) => {
    const [loading, setLoading] = useState(false);
    const [relationships, setRelationships] = useState([]);
    const [evlTitle, setEvlTitle] = useState(null);

    useEffect(() => {
        if (visible && evl_id) {
            getEvaluationRelationshipsLinks()
        }
    }, [visible, evl_id]);

    const getEvaluationRelationshipsLinks = () => {
        setLoading(true);
        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.get(`${apiUrl}/evaluation-relationships/get-evaluation-relationships-links/${evl_id}/`, headers)
            .then(function (response) {
                const data = response.data.employees;
                const evlTitle = response.data.title;
                setRelationships(data);
                setEvlTitle(evlTitle);
                setLoading(false);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
            });
    }

    const refreshTable = () => {
        getEvaluationRelationshipsLinks()
    }

    useEffect(() => {
        if (relationships) {
            setLoading(false);
        }
    }, [relationships]);

    return (
        <Modal
            title={`ENLACES ${evlTitle ? evlTitle.toUpperCase() : "EVALUACIÓN"}`}
            open={visible}
            onCancel={onClose}
            footer={null}
            destroyOnClose
            width="95%"
            maskClosable={false}
        >
            {loading ? (
                <div className="display-center-row display-center-column align-full-center">
                    <Spin />
                </div>
            ) : (
                <TableRelationshipsLinks
                    evl_relationships={relationships}
                    evl_id={evl_id}
                    evl_title={evlTitle}
                    refreshTable={refreshTable}
                />
            )}
        </Modal>
    );
};

export default ModalEvaluationLinks;
